var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCinedMarkGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 306.06 500",
    style: {
      enableBackground: "new 0 0 306.06 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#CC9933;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0,153.03 0,153.03 0,153.03  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.62,166.67H0v-13.64C0,157.63,0.22,162.17,0.62,166.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.11,153.03c0,4.64-0.38,9.19-1.1,13.64c-6.62,40.84-42.39,72.44-84.98,72.44 c-42.59,0-78.36-31.6-84.98-72.44c-0.72-4.45-1.1-9-1.1-13.64c0-47.22,38.86-86.08,86.08-86.08 C200.25,66.95,239.11,105.81,239.11,153.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.03,0C69.08,0,0,69.07,0,153.03c0,4.6,0.22,9.14,0.62,13.64c1.59,17.67,6.23,34.53,13.41,50.02 l51.53,116.64l68.03,154c7.46,16.89,31.42,16.89,38.88,0l68.03-154l51.53-116.64c7.18-15.49,11.82-32.35,13.41-50.02 c0.4-4.5,0.62-9.05,0.62-13.64C306.06,69.08,236.98,0,153.03,0z M153.03,239.11c-42.59,0-78.36-31.6-84.98-72.44 c-0.72-4.45-1.1-9-1.1-13.64c0-47.22,38.86-86.08,86.08-86.08c47.22,0,86.08,38.86,86.08,86.08c0,4.64-0.38,9.19-1.1,13.64 C231.39,207.51,195.62,239.11,153.03,239.11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinedMarkGold);
export default __webpack_public_path__ + "static/media/CINED_Mark_gold.f8668d9d69b99c2725909edd92e39355.svg";
export { ForwardRef as ReactComponent };